module.exports = __webpack_public_path__ + "img/refresh.ee276a99.png";